(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name payment.controller:PaymentCtrl
	 *
	 * @description
	 *
	 */
	angular.module('paymentPlannedActual').controller('paymentPlannedActualCtrl', paymentPlannedActualCtrl);

	function paymentPlannedActualCtrl(CommonMasterData, $sce, CommonLogicService) {
		var vm = this;
		vm.ctrlName = 'paymentPlannedActualCtrl';
		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				crewType : {
					crewTypeCode : ""
				},
				crewTypeCodesList : [],
				crewIds : null,
				currency : null,
				excludeOtherHubCrew:false,
				activeCrew:false
			},
			masterList : {
				crewTypes : [],
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false,
				crewIdsInvalid : false,
        crewTypeRequired : false
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null,
		};

    setDefaultSearchDays();
		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
      vm.model.masterList.crewIdsInvalid = false;
      searchPaymentReport(params);
		};

		// on change search field
		vm.changeSearchField = function() {
			setDateValidationFlags();
      var tempFromDate = moment(vm.model.searchCriteria.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
      if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
        if (vm.model.searchCriteria.toDate ==null){
          vm.model.searchCriteria.toDate = tempFromDate;
        }

      }
			if (!vm.model.masterList.toDateFormatInvalid && !vm.model.masterList.fromDateFormatInvalid && !vm.model.masterList.isToDateFutureDate) {
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				} else {
					vm.model.masterList.fromDateAfterToDate = false;
				}
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}
		};

		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}

			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
				vm.model.masterList.isToDateFutureDate = false;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
				if (!!vm.model.searchCriteria.toDate) {
					vm.model.masterList.isToDateFutureDate = istoDateFutureDate();
				} else {
					vm.model.masterList.isToDateFutureDate = false;
				}
			}
		}

		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		// check to date is a future date
		function istoDateFutureDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isAfter(moment().toDate());
		}
		;

		function searchPaymentReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.masterList.crewTypeRequired = false;
				vm.model.masterList.crewIdsInvalid = false;
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService.getReportUrl(
						"payment_actual_planned_report.rptdesign", getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url)
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
      searchParamMap["crewType"] = adaptCrewType(param.crewTypeCodesList);
			searchParamMap["currency"] = param.currency;
			if(!!param.crewIds && param.crewIds !== ""){
				searchParamMap["crewIds"] = param.crewIds;
			}

			searchParamMap["excludeOtherHubCrew"] = param.excludeOtherHubCrew;
			searchParamMap["activeCrew"] = param.activeCrew;

			return searchParamMap;
		}

		function adaptCrewType(crewTypeList) {
      var crewTypeCodeList = "";
      var count = 0;
      angular.forEach(crewTypeList, function(crewType){
        if(count !== 0){
          crewTypeCodeList += ",";
        }
        crewTypeCodeList += crewType.crewTypeCode;
        count ++;
      });

      return crewTypeCodeList;
    }

		function isValidSearchParams(params) {
			setDateValidationFlags();
			// if date invalid
			if (vm.model.masterList.toDateFormatInvalid
					|| vm.model.masterList.fromDateFormatInvalid) {
				return false;
			} else if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
				return false;
			}else if (vm.model.searchCriteria.crewTypeCodesList.length === 0 || vm.model.searchCriteria.crewTypeCodesList === null) {
			  vm.model.masterList.crewTypeRequired = true;
				return false;
			}
			return true;

		}

		(
		function loadCrewTypes() {
			// load crew Types
			CommonMasterData.getCrewTypeList(function(crewTypes) {
				vm.model.masterList.crewTypes = crewTypes;
			}, function() {
				console.log('Crew type retrieval error');
			});
			// load currency
			CommonMasterData.getCurrency(function(currency) {
				vm.model.searchCriteria.currency = currency;
			}, function() {
				console.log('Currency retrieval error');
			});
		}

		)();

    function setDefaultSearchDays(){
      if(!vm.model.searchCriteria.fromDate){
        var moStart = moment().startOf("month");
        var moEnd = moment().endOf("month");
        vm.model.searchCriteria.fromDate = moStart.format('DD/MM/YYYY');
        vm.model.searchCriteria.toDate = moEnd.format('DD/MM/YYYY');
      }
    }

    function validateCrewIdsAndSearch(param) {
      CommonMasterData.getCrewTypesForCrewIds(param.crewIds,param.fromDate,param.toDate, function(response) {
	        if (param.crewIds === null || param.crewIds === "" || checkCrewValidity(response)){
                vm.model.masterList.crewIdsInvalid = false;
		            searchPaymentReport(param);
	        }

      }, function(error) {
            console.log("Error validating crew ids");
      }
      );
    }

    function checkCrewValidity(resultList) {
    	if (resultList.length === 1) {
		      if (typeof vm.model.searchCriteria.crewType === 'undefined') {
			          vm.model.searchCriteria.crewType = {};
		      }
		      else {
			          vm.model.searchCriteria.crewType.crewTypeCode = resultList[0];
		      }
		      return true;
		  }
    	else {
		      vm.model.masterList.crewIdsInvalid = true;
    		  return false;
    	}
	}

}
}());
